import { createApp, ref } from 'vue';
import 'bootstrap';

import '../styles/app.scss';

import { register } from 'swiper/element/bundle';

import Example from './components/ExampleComponent.vue';
import Featuredvideo from './components/FeaturedVideo.vue';
import RegisterForm from './components/RegisterForm.vue';
import Product from './components/Product.vue';
import Quatity from './components/Quatity.vue';
import Share from './components/Share.vue';
import Counter from './components/CounterQuantity.vue';
import cartManager from './lib/cartManager.mjs';

import Contact from './components/Contact.vue';
import AddressForm from './components/AddressForm.vue';

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';

// import required modules
import { Navigation, Pagination, Grid } from 'swiper/modules';

const soCartManager = new cartManager();
window.soCartManager = soCartManager;

function createVueApp(){
  return createApp({
    el: '#so_app',
    name: 'Sodigital',
    components: {
      'example' : Example,
      'featured-video': Featuredvideo,
      'register-form': RegisterForm,
      'product': Product,
      'quantity': Quatity,
      'share': Share,
      'counter-component': Counter,
      'contact': Contact,
      'address-form': AddressForm,
      Swiper,
      SwiperSlide
    },
    setup() {
      const modules = [Navigation, Pagination, Grid];
      const prodMainSlider = ref(null);
      const prodMainSliderThumbs = ref(null);
      const onSwiperFunction = (swiper) => {
         prodMainSlider.value = swiper;
         prodMainSliderThumbs.value = swiper;
      };
      return {
        modules: modules,
        onSwiperFunction: onSwiperFunction
      };
    },
    data() {
      return {
        swiper: ref(null)
      };
    },
    methods:{
      onSwiper(){
        this.onSwiperFunction();
      },
      changeSlide(index){
        const prodMainSlider = document.querySelector("#prodMainSlider");
        const prodMainSliderThumbs = document.querySelector("#prodMainSliderThumbs");
        prodMainSlider.swiper.slideTo(index);
        prodMainSliderThumbs.swiper.slideTo(index);
      }
    },
    mounted() {
      console.log('tiene vue');
    }
  }).mount('#so_app');
}

function createVueAppHeader(){
  return createApp({
    el: '#so_app_header',
    name: 'Sodigital Header',
    components: {
      'example' : Example
    },
    data() {
      return {
      };
    },
    methods:{
    },
    mounted() {
      console.log('tiene vue en el header');
    }
  }).mount('#so_app_header');
}

function createVueAppFooter(){
  return createApp({
    el: '#so_app_footer',
    name: 'Sodigital Footer',
    components: {
      'example' : Example
    },
    data() {
      return {
      };
    },
    methods:{
    },
    mounted() {
      console.log('tiene vue en el footer');
    }
  }).mount('#so_app_footer');
}

window.addEventListener('load', function () {
  register();

  const app = createVueApp();
  const appFooter = createVueAppFooter();
  const appHeader = createVueAppHeader();
  const swiperEl = document.querySelector('.slide--grid') ? document.querySelector('.slide--grid') : '';

  if(swiperEl) {
    Object.assign(swiperEl, {
      breakpoints: {
        250: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3,
          grid: {
            rows: 2,
            fill: 'row'
          },
          spaceBetween: 12,
        },
      },
    });
    swiperEl.initialize();
  }
});




